module.exports = __webpack_public_path__ + "static/media/trust.ce68117c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Heathbot/trust.jpg
// module id = 191
// module chunks = 0